import { store } from 'plugins/store/store';
import { get } from 'lodash';

const canByLicensing = (licensesFeatureName = null) => {
	const state = store.getState();
	const features = state.settings?.licenseSettings?.features || {};

	if (licensesFeatureName === null) {
		return true;
	}

	if (licensesFeatureName.$or) {
		return licensesFeatureName.$or.some((lfn) => get(features, lfn));
	}

	if (licensesFeatureName.$and) {
		return licensesFeatureName.$and.every((lfn) => get(features, lfn));
	}

	return get(features, licensesFeatureName);
}

export { canByLicensing };
